<div class="section">
  <div class="title"><span i18n="@@modifySocio">Modifica socio:</span> {{socio.nomeCompleto}} </div>
  <form #modifySocioForm="ngForm" (ngSubmit)="modifySocio()">
    <div class="card">
      <div class="card-content">
        <div *ngIf="socio.temporary" class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@name" [ngClass]="{'has-text-danger' : !socio.nome1}">Nome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.nome1" name="nome1FieldName"
                       required type="text" #nome1Field="ngModel" [ngClass]="{'is-danger' : !socio.nome1}">
              </div>
              <p class="help is-danger" *ngIf="nome1Field.invalid && (nome1Field.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="socio.temporary" class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@surname" class="label" [ngClass]="{'has-text-danger' : !socio.nome2}">Cognome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.nome2" name="nome2FieldName"
                       required type="text" #nome2Field="ngModel" [ngClass]="{'is-danger' : !socio.nome2}">
              </div>
              <p class="help is-danger" *ngIf="nome2Field.invalid && (nome2Field.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@birthDate" [ngClass]="{'has-text-danger' : !dateModel}">Data nascita</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control has-icons-right">
                <!-- <input class="input" [owlDateTimeTrigger]="dt" [owlDateTime]="dt"
                       [(ngModel)]="dateModel" #dateField="ngModel"
                       name="datanascitaField" required
                       [ngClass]="{'is-danger' : !dateModel}">
                <span class="icon is-small is-right">
                  <i class="far fa-calendar-alt"></i>
                </span>
                <owl-date-time pickerType="calendar" [firstDayOfWeek]="1" #dt></owl-date-time> -->
              </div>
              <!-- <p class="help is-danger" *ngIf="dateField.invalid && (dateField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p> -->

            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@birthPlace" class="label" [ngClass]="{'has-text-danger' : !socio.luogoNascita}">Luogo nascita</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.luogoNascita" name="luogoFieldName" maxlength="50"
                       required type="text" #luogoField="ngModel" [ngClass]="{'is-danger' : !socio.luogoNascita}">
              </div>
              <p class="help is-danger" *ngIf="luogoField.invalid && (luogoField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@sex">Sesso</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input class="is-checkradio" id="mField" type="radio" name="mField" value="M" [(ngModel)]="socio.sesso">
              <label for="mField">M</label>
              <input class="is-checkradio" id="fField" type="radio" name="fField" value="F" [(ngModel)]="socio.sesso">
              <label for="fField">F</label>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal" [ngClass]="{'has-text-danger' : !socio.indirizzo}">
            <label class="label" i18n="@@address" >Indirizzo</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.indirizzo" name="indirizzoFieldName" maxlength="255"
                       required type="text" #addressField="ngModel" [ngClass]="{'is-danger' : !socio.indirizzo}">
              </div>
              <p class="help is-danger" *ngIf="addressField.invalid && (addressField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@city"
                   [ngClass]="{'has-text-danger' : !socio.citta}">Città</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.citta" name="cittaFieldName" maxlength="100"
                       required type="text" #cityField="ngModel" [ngClass]="{'is-danger' : !socio.citta}">
              </div>
              <p class="help is-danger" *ngIf="cityField.invalid && (cityField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@zone"
                   [ngClass]="{'has-text-danger' : !socio.provincia}">Provincia</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.provincia" name="provinciaFieldName" maxlength="2"
                       required type="text" #provinciaField="ngModel" [ngClass]="{'is-danger' : !socio.provincia}">
              </div>
              <p class="help is-danger" *ngIf="provinciaField.invalid && (provinciaField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.cap" name="capFieldName" maxlength="10" 
                       required type="text" placeholder="CAP" i18n-placeholder="@@zipCode" #capField="ngModel" [ngClass]="{'is-danger' : !socio.cap}">
              </div>
              <p class="help is-danger" *ngIf="capField.invalid && (capField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@country" class="label" [ngClass]="{'has-text-danger' : !socio.codStato}">Nazione</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select" [ngClass]="{'is-danger' : countryField.invalid && (countryField.touched || modifySocioForm.submitted)}">
                  <select style="width:100%" name="nazioneField" [(ngModel)]="socio.codStato" required #countryField="ngModel" [ngClass]="{'is-danger' : !socio.codStato}">
                    <option *ngFor="let nazione of nazioni" [ngValue]="nazione.twoLetterIsoCode">
                      {{nazione.twoLetterIsoCode}} - {{nazione.name}}
                    </option>
                  </select>
                </div>
              </div>
              <p class="help is-danger" *ngIf="countryField.invalid && (countryField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@taxCode"
                   [ngClass]="{'has-text-danger' : (socio.codStato == 'IT' && !socio.codFiscale)}" class="label">Codice Fiscale</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.codFiscale" name="codFiscFieldName"
                type="text" maxlength="20"
                #codFiscField="ngModel" [required]="(socio.codStato == 'IT') ? '' : null"
                [ngClass]="{'is-danger' : socio.codStato == 'IT' && !socio.codFiscale}">
              </div>
              <p class="help is-danger" *ngIf="codFiscField.invalid && (codFiscField.touched || modifySocioForm.submitted)" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label [ngClass]="{'has-text-danger' : emailField.invalid && (emailField.touched || modifySocioForm.submitted)}" class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.email" name="emailFieldName" type="text" email
                       #emailField="ngModel" maxlength="50"
                       [ngClass]="{'is-danger' : emailField.invalid && (emailField.touched || modifySocioForm.submitted)}" >
              </div>
              <p class="help is-danger" *ngIf="emailField.invalid && (emailField.touched || modifySocioForm.submitted)" i18n="@@mailNotValid">
                Mail non valida
              </p>
            </div>
            <div class="field">
              <div class="control">
                <input type="checkbox" class="is-checkradio" id="newsletterCheckbox"
                       [(ngModel)]="socio.newsletter" [disabled]="!socio.email" name="newsLetterField">
                <label  for="newsletterCheckbox">Newsletter</label>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@telephoneNumber" class="label">Telefono</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.telefono" name="telefonoFieldName" type="text" maxlength="255">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@mobilePhoneNumber" class="label">Cellulare</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.cellulare" maxlength="20"
                       name="cellulareFieldName" type="text" #cellField="ngModel" >
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@association" class="label">Associazione</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select">
                  <select name="associazioneField" #associazioneField="ngModel"
                          [ngModel]="socio.idAssociazione" (ngModelChange)="onChangeAssociazione($event)">
                    <option [ngValue]="undefined" i18n="@@selectInsurance">--Seleziona associazione--</option>
                    <option *ngFor="let associazione of associazioni" [ngValue]="associazione.id">
                      {{associazione.ragioneSociale}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@cardAssociation"
                   [ngClass]="{'has-text-danger' : socio.idAssociazione && !socio.tesseraAssociazione}">Tess.Ass.</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [disabled]="!socio.idAssociazione" [(ngModel)]="socio.tesseraAssociazione" name="tesseraAssociazioneFieldName"
                       type="text" #tesseraAssociazioneField="ngModel" maxlength="255"
                       [ngClass]="{'is-danger' : socio.idAssociazione && !socio.tesseraAssociazione}"
                       [required]="socio.idAssociazione ? '' : null">
              </div>
              <p class="help is-danger" *ngIf="socio.idAssociazione && !socio.tesseraAssociazione" i18n="@@dataRequired">
                Dato richiesto
              </p>
              <p class="notification is-primary is-size-7">
                Primar lorem ipsum dolor sit amet, consectetur
                adipiscing elit lorem ipsum dolor. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Sit amet,
                consectetur adipiscing elit
              </p>
            </div>
          </div>
        </div>

        <div class="field is-grouped field is-grouped-right">
          <div class="control">
            <a [routerLink]="['/area-utente', 'gruppo']" i18n="@@cancel" class="button is-danger">Annulla</a>
          </div>
          <div class="control">
            <button type="submit" i18n="@@save" class="button is-primary">Salva</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
